export async function captureTab() {
    return '<screenshot>'
}